import * as actionTypes from "./actionTypes";
import initialState from "reducers/initialState";
import * as hierarchyImportEventTypes from "./eventTypes";

export const assetHierarchyReducer = (state = initialState.currentOffer.assetData.inEdit.hierarchy, action) => {
  switch (action.type) {
    case hierarchyImportEventTypes.ASSET_HIERARCHY_IMPORT_COMPLETED:
      return { ...initialState.currentOffer.assetData.inEdit.hierarchy, reload: true };

    default:
      return state;
  }
};

export const assetHierarchiesReducer = (state = initialState.assetData.hierarchies, action) => {
  switch (action.type) {
    case actionTypes.LOAD_ASSET_HIERARCHY_LEVELS_SUCCESS: {
      return {
        ...state,
        [action.payload.id]: [...action.payload.levels]
      };
    }

    default:
      return state;
  }
};

export const assetHierarchyPropertiesReducer = (state = initialState.assetData.assetHierarchyProperties, action) => {
  switch (action.type) {
    case actionTypes.LOAD_ASSET_HIERARCHY_PROPERTIES_SUCCEEDED: {
      return {
        ...state,
        [action.payload.id]: [...action.payload.properties]
      };
    }
    default:
      return state;
  }
};
